// extracted by mini-css-extract-plugin
module.exports = {"button":"SubBrandTab_button__U60gd","wrapperText":"SubBrandTab_wrapperText__OgqS4","selected":"SubBrandTab_selected__m058R"};